import HttpHelpers from '../helpers';

const BookingsApiEndpoints = {
  getGuestBookings: (params) => {
    return HttpHelpers.authenticatedAxios
      .get('booking', { params })
      .then((response) => response.data);
  },
  reviewBooking: (reviewId, data) => {
    return HttpHelpers.authenticatedAxios
      .put(`booking/review/${reviewId}`, data)
      .then((response) => response.data);
  },
};

export default BookingsApiEndpoints;
